module.exports = {"460400100":"那大镇","460400101":"和庆镇","460400102":"南丰镇","460400103":"大成镇","460400104":"雅星镇","460400105":"兰洋镇","460400106":"光村镇","460400107":"木棠镇","460400108":"海头镇","460400109":"峨蔓镇","460400111":"王五镇","460400112":"白马井镇","460400113":"中和镇","460400114":"排浦镇","460400115":"东成镇","460400116":"新州镇","460400499":"洋浦经济开发区","460400500":"华南热作学院"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460400.json
// module id = 2324
// module chunks = 0